const FindNearbyLabsIcon = ({ className = '' }) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M32 10C23.716 10 17 16.716 17 25C17 36.25 32 50 32 50C32 50 47 36.25 47 25C47 16.716 40.284 10 32 10Z"
        fill="#7C6BE0"
      />
      <path
        d="M32 50C32 50 47 36.25 47 25C47 16.716 40.284 10 32 10V50Z"
        fill="#6354C0"
      />
      <circle cx="32" cy="25" r="8" fill="white" />
      <path
        d="M35.5 24H33V21.5C33 21.224 32.776 21 32.5 21H31.5C31.224 21 31 21.224 31 21.5V24H28.5C28.224 24 28 24.224 28 24.5V25.5C28 25.776 28.224 26 28.5 26H31V28.5C31 28.776 31.224 29 31.5 29H32.5C32.776 29 33 28.776 33 28.5V26H35.5C35.776 26 36 25.776 36 25.5V24.5C36 24.224 35.776 24 35.5 24Z"
        fill="#7C6BE0"
      />
    </svg>
  )
}

export default FindNearbyLabsIcon
